import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const cashierApiSlice = createApi({
  reducerPath: "cashierApi",
  baseQuery: fetchBaseQuery({
    baseUrl: "https://castle-auction-production.up.railway.app/api/",
    prepareHeaders: (headers) => {
      headers.set("Content-Type", "application/json");
      const token = localStorage.getItem("auction_portal");
      if (token) {
        headers.set("x-auth-token", token);
      }
      return headers;
    },
  }),
  tagTypes: ["Cashier"],
  endpoints: (builder) => ({
    cashier: builder.query({
      query: ({ endpoint, lastId, params }) => {
        const url = lastId ? `${endpoint}${lastId}` : endpoint;
        return {
          url,
          method: "GET",
          params: params || undefined,
        };
      },
      providesTags: (result) =>
        result
          ? [
              ...result.staff.map(({ _id }) => ({
                type: "Cashier",
                id: _id,
              })),
              { type: "Cashier", id: "LIST" },
            ]
          : [{ type: "Cashier", id: "LIST" }],
    }),

    // createCategory: builder.mutation({
    //   query: ({ endpoint, formData }) => ({
    //     url: endpoint,
    //     method: "POST",
    //     body: formData,
    //   }),
    //   // Wait for the API response before updating the cache
    //   async onQueryStarted(
    //     { endpoint, formData, lastId },
    //     { dispatch, queryFulfilled }
    //   ) {
    //     try {
    //       const { data } = await queryFulfilled; // wait for the real API response
    //       if (data && data.category && data.category._id) {
    //         // Update the paginated query cache (if using a page-based cache)
    //         dispatch(
    //           cashierApiSlice.util.updateQueryData(
    //             "categories",
    //             { endpoint: allCatUsingPaging, id: lastId },
    //             (draft) => {
    //               // Insert the new lot at the beginning (top)
    //               draft.categories.unshift(data.category);
    //             }
    //           )
    //         );
    //       }
    //     } catch (error) {
    //       console.error("Create failed:", error);
    //     }
    //   },
    // }),

    // updateCategory: builder.mutation({
    //   query: ({ endpoint, id, formData }) => ({
    //     url: `${endpoint}/${id}`,
    //     method: "PUT",
    //     body: formData,
    //   }),
    //   // Wait for API response before updating the cache
    //   async onQueryStarted(
    //     { endpoint, id, formData, lastId },
    //     { dispatch, queryFulfilled }
    //   ) {
    //     try {
    //       const { data } = await queryFulfilled; // wait for the API call to complete
    //       if (data && data.category) {
    //         // Update paginated cache if applicable
    //         dispatch(
    //           cashierApiSlice.util.updateQueryData(
    //             "categories",
    //             { endpoint: allCatUsingPaging, id: lastId },
    //             (draft) => {
    //               const index = draft.categories.findIndex((a) => a._id === id);
    //               if (index !== -1) {
    //                 draft.categories[index] = data.category;
    //               }
    //             }
    //           )
    //         );
    //       }
    //     } catch (error) {
    //       console.error("Update failed:", error);
    //       // Handle rollback if needed
    //     }
    //   },
    // }),

    // deleteCategory: builder.mutation({
    //   query: ({ endpoint, id }) => ({
    //     url: `${endpoint}/${id}`,
    //     method: "PUT",
    //   }),
    //   // Optimistic update for delete
    //   async onQueryStarted(id, { dispatch, queryFulfilled, getState }) {
    //     // Get the current lastId from state if necessary
    //     // For this example, we're using a fixed lastId
    //     const lastId = 1;

    //     // Remove from lots list query
    //     const patchResult = dispatch(
    //       cashierApiSlice.util.updateQueryData(
    //         "categories",
    //         { id: lastId },
    //         (draft) => {
    //           if (draft && draft.categories) {
    //             draft.categories = draft.categories.filter(
    //               (item) => item._id !== id
    //             );
    //           }
    //         }
    //       )
    //     );

    //     try {
    //       // Wait for the actual API request to complete
    //       await queryFulfilled;
    //       // No need to invalidate tags - we've already updated the cache
    //     } catch (error) {
    //       // If the mutation fails, undo the optimistic update
    //       patchResult.undo();
    //       console.error("Delete lot failed:", error);
    //     }
    //   },
    // }),

    // // Add this new endpoint to force-refresh lot data if needed
    // refreshCategories: builder.query({
    //   query: () => "allCatUsingPaging",
    //   providesTags: [{ type: "Lots", id: "LIST" }],
    // }),
  }),
});

export const { useCashierQuery } = cashierApiSlice;
